<div class="flex flex-col w-full">
  @if (loading) {
    <div class="flex justify-center items-center py-8">
      <div class="text-white/60 text-sm">{{ loadingText }}</div>
    </div>
  } @else {
    <div
      class="grid w-full gap-4"
      [ngClass]="{
        'grid-cols-1': gridColumns === 1,
        'grid-cols-1 sm:grid-cols-2': gridColumns === 2,
        'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3': gridColumns === 3,
        'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4': gridColumns === 4
      }"
    >
      @for (option of options; track option.value) {
        <div
          class="relative flex flex-col items-center justify-center gap-4 p-6 rounded-2xl cursor-pointer transition-all duration-200 ease-in-out border border-solid"
          [ngClass]="{
            'bg-theme-background/10 hover:bg-theme-background/20 shadow-[inset_0_0_26px_rgba(255,255,255,0.11)]': !isOptionSelected(option.value),
            'bg-theme-background/20 shadow-[inset_0_0_26px_rgba(30,144,255,0.35)]': isOptionSelected(option.value),
            'border-white/5': !isOptionSelected(option.value) && !(formControl.invalid && formControl.touched),
            'border-cyan-highlight': isOptionSelected(option.value),
            'border-error': formControl.invalid && formControl.touched && !isOptionSelected(option.value),
            'opacity-50 cursor-not-allowed': option.disabled || formControl.disabled
          }"
          [attr.tabindex]="option.disabled || formControl.disabled ? -1 : 0"
          (click)="selectOption(option)"
          (keyup.enter)="selectOption(option)"
        >
          <div
            class="flex items-center justify-center w-16 h-16 rounded-full transition-colors duration-200"
            [ngClass]="{
              'bg-white/5': !isOptionSelected(option.value),
              'bg-cyan/50': isOptionSelected(option.value)
            }"
          >
            <nrc-icon
              [name]="option.icon"
              class="w-6 h-6"
              [ngClass]="{
                'text-white/60': !isOptionSelected(option.value),
                'text-cyan-highlight': isOptionSelected(option.value)
              }"
            />
          </div>

          <div class="flex flex-col items-center gap-1 text-center">
            <span
              class="text-sm font-medium tracking-wide transition-colors duration-200"
              [ngClass]="{
                'text-white/60': !isOptionSelected(option.value),
                'text-white': isOptionSelected(option.value)
              }"
            >
              {{ option.label }}
            </span>

            @if (option.description) {
              <span
                class="text-xs font-light transition-colors duration-200"
                [ngClass]="{
                  'text-white/40': !isOptionSelected(option.value),
                  'text-white/60': isOptionSelected(option.value)
                }"
              >
                {{ option.description }}
              </span>
            }
          </div>
        </div>
      }
    </div>
  }

  @if (hint) {
    <p class="text-xs text-white/50 py-1 mt-2">
      {{ hint }}
    </p>
  }

  @if (invalidHint && formControl.invalid && formControl.touched) {
    <p class="text-xs text-error leading-tight tracking-[.01125em] pt-1 mt-2">
      {{ invalidHint }}
    </p>
  }
</div>

